import { Link, useLocation } from "react-router-dom";
import { CONTACT_ADDRESS, RoomsNav, usePageMeta } from "@/lib/site";

export default function Room({ title, description, children }) {
  const { pathname } = useLocation();
  usePageMeta(`${title} · MAATTR`, description);
  return (
    <div className="room" data-testid={`room-${pathname.slice(1)}`}>
      <header className="top">
        <Link className="mark" to="/" data-testid="room-mark">MAATTR</Link>
      </header>
      <main>{children}</main>
      <div className="roomwrap"><RoomsNav /></div>
      <footer data-testid="room-footer">
        <span data-testid="footer-anchor">MAATTR · Est. 2024</span>
        <span data-testid="footer-address">{CONTACT_ADDRESS}</span>
      </footer>
    </div>
  );
}
